export const WEBSOCKET_CONFIG = {
  TRANSACTION_LIMIT: 5,
  RECONNECT_MAX_ATTEMPTS: 3,
  RECONNECT_DELAY: 1000,
  MESSAGE_TIMEOUT: 5000,
  TOPIC: 'transaction',
}

export const WEBSOCKET_MESSAGE_TYPES = {
  TRANSACTION: 'transaction',
  EMPLOYEE: 'employee',
  HARDWARE: 'hardware',
}
